import { ApiError } from 'core/errors/ApiError';

export function asObject(value) {
  return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
}

export function unwrapEnvelope(payload, fallbackMessage = 'Request failed') {
  if (payload == null || typeof payload !== 'object' || Array.isArray(payload)) {
    throw new ApiError({
      status: 0,
      message: fallbackMessage,
      payload,
      isMalformed: true,
    });
  }

  const errors = asObject(payload.errors);
  const data = asObject(payload.data);

  if (payload.success === false) {
    throw new ApiError({
      status: 0,
      message: payload.message || fallbackMessage,
      errors,
      data,
      payload,
    });
  }

  if (Object.prototype.hasOwnProperty.call(payload, 'data')) {
    return payload.data;
  }

  return payload;
}

export function asPaginated(data) {
  if (!data || typeof data !== 'object') {
    return {
      items: [],
      meta: { current_page: 1, last_page: 1, per_page: 15, total: 0 },
    };
  }
  const items = Array.isArray(data.items)
    ? data.items
    : (Array.isArray(data.data) ? data.data : (Array.isArray(data) ? data : []));
  const meta = data.meta && typeof data.meta === 'object'
    ? data.meta
    : {
      current_page: Number(data.current_page) || 1,
      last_page: Number(data.last_page) || 1,
      per_page: Number(data.per_page) || items.length || 15,
      total: Number(data.total) || items.length,
    };
  return { items, meta };
}
